import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOfferMigrate = createMutationHook(OffersApiClient.migrate, {
  mutationKey: ['offerMigrate'],
})
